export default __webpack_public_path__ + "static/media/gardient.71ad3d89.png";